import Button from "@mui/material/Button";
import { RouteAccessState, getRouteAccessState } from "constants/access";
import ROUTES from "constants/routes";
import { UserContext } from "context/userContext";
import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
// import typography from "constants/typography.constants";

const PAGES = [
  { title: "Карты компетенций", link: `/${ROUTES.COMPETENCE_MAPS}` },
  // { title: typography.scenario.title, link: `/${ROUTES.SCENARIOS}` },
  // TODO: завершить скрытие страницы
  // { title: "Блоки знаний", link: `/${ROUTES.KNOWLEDGE_BLOCKS}` },
  { title: "Тестирования", link: `/${ROUTES.TESTING}` },
  { title: "Кандидаты", link: `/${ROUTES.CANDIDATE}` },
  { title: "Вакансии", link: `/${ROUTES.VACANCIES}` },
  { title: "Моя компания", link: `/${ROUTES.COMPANY}` },
];

const Navigation = ({ isAuth }: { isAuth: boolean }) => {
  const location = useLocation();
  const { currentCompanyRole } = useContext(UserContext);

  return (
    isAuth &&
    PAGES.filter((page) => getRouteAccessState(page.link, currentCompanyRole) === RouteAccessState.ALLOWED).map(
      (page) => {
        const isCurrentPage = location.pathname.includes(page.link);
        return (
          <Button
            color='secondary'
            size='medium'
            disableRipple
            key={page.link}
            sx={{
              paddingX: 1,
              wordBreak: "normal",
              pb: 0,
              ...(isCurrentPage && { color: "primary.dark" }),
            }}
            component={Link}
            to={page.link}>
            {page.title}
          </Button>
        );
      }
    )
  );
};

export default Navigation;
